.label {
  color: var(--text-primary);
  padding-right: 2px;
}
